import React, { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { useGlobalEvent } from "../../common/hooks/useGlobalEvent";
import Toast from "../Toast";
import { TOAST_EVENTS } from "../Toast/constants";

const ToastContainer: React.FC = () => {
	const { t } = useTranslation();
	const [showToast, setShowToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");

	const handleShowAddToast = useCallback(() => {
		setToastMessage(t("toast.itemAdded"));
		setShowToast(true);
	}, [t]);

	const handleShowRemoveToast = useCallback(() => {
		setToastMessage(t("toast.itemRemoved"));
		setShowToast(true);
	}, [t]);

	const handleHideToast = useCallback(() => {
		setShowToast(false);
	}, []);

	useGlobalEvent(TOAST_EVENTS.SHOW_ADD_ITEM_TOAST, handleShowAddToast);
	useGlobalEvent(TOAST_EVENTS.SHOW_REMOVE_ITEM_TOAST, handleShowRemoveToast);

	if (!showToast) return null;

	return <Toast message={toastMessage} onHide={handleHideToast} />;
};

export default memo(ToastContainer);
